import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { UnclaimParkingStickerButton } from '@shared/parking-requests/components/UnclaimParkingStickerButton';
import { HandOutParkingStickerButton } from '@shared/parking-stickers/components/HandOutParkingStickerButton';

import ListView from '../../../base/ListView';
import { ajaxErrorHandler, formatUTCDate } from '../../../libs/utils';
import { selectEvent } from '../../../redux/preferences/selectors';
import { getCompanies } from '../../../services/api/companies';
import { getCrewMembers } from '../../../services/api/crewMembers';
import { getParkingStickers } from '../../../services/api/parkingVouchers';
import { getParkings } from '../../../services/api/parkings';
import AdminSubHeader from '../../layouts/partials/AdminSubheader';

const ParkingStickers = () => {
  const event = useSelector(selectEvent);
  const [stickers, setStickers] = useState([]);
  const [stickersMeta, setStickersMeta] = useState({});
  const [loading, setLoading] = useState(true);
  const [parkings, setParkings] = useState([]);
  const [baseFilters, setBaseFilters] = useState({
    'page[number]': 1,
    'page[size]': 50,
    'sort': '-updated_at',
    'include':
      'claimed-by-crew-member,claimed-by-crew-member.user,claimed-by-crew-member.registration,claimed-by-crew-member.registration.company,parking-sticker.parking,parkingRequest.registration.company',
  });

  useEffect(() => {
    loadParkings();
  }, []);

  useEffect(() => {
    loadStickers();
  }, [baseFilters]);

  const loadStickers = () => {
    getParkingStickers(event.id, baseFilters)
      .then((response) => {
        setStickers(response.data);
        setStickersMeta(response.meta);
      })
      .catch(ajaxErrorHandler)
      .then(() => {
        setLoading(false);
      });
  };

  const loadParkings = () => {
    getParkings(event.id, { 'page[size]': 50 }).then((response) => {
      setParkings(response.data);
    });
  };

  const handleDelete = () => {
    console.log('haha');
  };

  const listViewConf = {
    dataSet: stickers,
    dataMeta: stickersMeta,
    columns: [
      {
        key: 'code',
        value: 'Code',
      },
      {
        key: 'parkingSticker.parking.name',
        value: 'Parking',
      },
      {
        key: 'parkingSticker.name',
        value: 'Sticker',
      },
      {
        key: 'parkingRequest.registration.company.name',
        value: 'Company',
      },
      {
        key: 'claimedByCrewMember',
        value: 'Crew Member',
        render: (item) =>
          item.claimedByCrewMember
            ? item.claimedByCrewMember?.user.firstName + ' ' + item.claimedByCrewMember?.user.lastName
            : null,
      },
      {
        key: 'claimedAt',
        value: 'Hand Out',
        render: (item) => item.claimedAt && formatUTCDate(item.claimedAt, 'DD/MM/YYYY HH:mm:ss'),
      },
      {
        key: 'actions',
        render: (item) => (
          <>
            {!item.claimedAt && (
              <HandOutParkingStickerButton parkingRequestParkingSticker={item} onHandOut={loadStickers} />
            )}
            {item.claimedAt && (
              <UnclaimParkingStickerButton parkingRequestParkingSticker={item} onUnclaim={loadStickers} />
            )}
          </>
        ),
      },
    ],
    baseFilters,
    filters: [
      {
        label: 'Code',
        icon: 'la-barcode',
        type: 'text',
        key: 'code',
      },
      {
        label: 'Company',
        icon: 'la-map-marker',
        type: 'typeahead',
        options: (value) =>
          getCompanies({
            'filter[name]': value,
          }),
        key: 'company_id',
        labelKey: 'name',
      },
      {
        label: 'Crew Member',
        icon: 'la-user',
        type: 'typeahead',
        options: (value) =>
          getCrewMembers({
            'filter[name_like]': value,
            'filter[event_id]': event.id,
            'include': 'user,registration,registration.company',
          }),
        key: 'claimed_by_crew_member_id',
        labelKey: (item) => `${item.user.firstName} ${item.user.lastName} (${item.registration.company.name})`,
      },
      {
        label: 'Parking',
        icon: 'la-car',
        key: 'parking_id',
        type: 'select',
        dataset: parkings.map((parking) => {
          return {
            key: parking.id,
            value: parking.name,
          };
        }),
      },
    ],
    actions: {
      deleteLink: false,
      editLink: false,
      detailsLink: false,
    },
    url: '/admin/parking-stickers',
  };

  return (
    <>
      <AdminSubHeader title="Parking Stickers" breadcrumbs={[]}>
        <Link
          to="/admin/parking-stickers/scanner"
          className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
        >
          <i className="la la-barcode" />
        </Link>
      </AdminSubHeader>
      <div className="m-content">
        <div className="row">
          <div className="col-xl-12">
            {loading ? (
              <span>Loading</span>
            ) : (
              <ListView config={listViewConf} handleDelete={handleDelete} handleFilterUpdate={setBaseFilters} />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ParkingStickers;
